export { default as RRPFootnote } from "./RRPFootnote";
export { showsRRPFootnote, RRP_FOOTNOTE_ROUTES } from "./rrp-footnote-routes";
